import { FormBase } from 'core/components';

export default class NikoPatientInsuranceInfoNoteModalForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'insuranceInfoNote',
                    label: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_TEMPLATE_ADD_NOTE_MODAL.NOTE_LABEL',
                    placeholder: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_TEMPLATE_ADD_NOTE_MODAL.NOTE_PLACEHOLDER',
                    rules: 'string'            
                },
            ],
        };
    }
}